import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { cleanExcerpt } from "@/lib/articleHtml";

export default function Articles() {
  const { data: articles = [], isLoading } = useQuery({ queryKey: ["articles"], queryFn: () => api.get("/articles").then((r) => r.data) });

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <Seo title="Articles & Insights" path="/articles"
        description="Teachings, reflections and practical wisdom from the Enhancing Your World community — mindfulness, healing, movement and conscious living." />
      <p className="eyw-label mb-3">Teachings & Reflections</p>
      <h1 className="font-serif text-4xl lg:text-6xl text-[#1A242B] mb-12">Articles</h1>

      {isLoading && <p className="text-[#4A5D6B]">Loading…</p>}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map((a) => (
          <Link key={a.id} to={`/articles/${a.slug || a.id}`} data-testid={`article-card-${a.id}`} className="eyw-card overflow-hidden group flex flex-col">
            {a.cover_image && (
              <div className="h-48 overflow-hidden">
                <img src={a.cover_image} alt={a.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
            )}
            <div className="p-7 flex flex-col flex-1">
              <span className="eyw-label mb-2">{a.category}</span>
              <h3 className="font-serif text-2xl text-[#1A242B] leading-snug">{a.title}</h3>
              <p className="text-[#4A5D6B] text-sm mt-3 leading-relaxed flex-1">{cleanExcerpt(a, 160)}</p>
              <span className="inline-flex items-center gap-1 text-[#144F75] text-sm font-medium mt-5 group-hover:gap-2 transition-all">Read <ArrowRight size={15} /></span>
            </div>
          </Link>
        ))}
      </div>
      {!isLoading && articles.length === 0 && <p className="text-[#4A5D6B]">No articles yet.</p>}
    </div>
  );
}
